export enum MemberManagementType {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  SUB_ROUNDTABLE = "SUB-ROUNDTABLE",
}
